import { api } from "../client";
import {
  DocumentInvoiceExtraFields,
  DocumentInvoiceFields,
  PartialDocumentInvoiceExtraFields,
  PartialDocumentInvoiceFields,
} from "../schema/DocumentInvoice";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  DocumentInvoiceFields,
  DocumentInvoiceExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDocumentInvoiceFields,
  PartialDocumentInvoiceExtraFields
>;

export const getDocumentInvoices = async (config?: ApiRequestConfig) => {
  return api.get<DocumentInvoiceFields, DocumentInvoiceExtraFields>(
    "document_invoices",
    config
  );
};
export const getDocumentInvoice = (id: number, config?: ApiRequestConfig) => {
  return api.get<DocumentInvoiceFields, DocumentInvoiceExtraFields>(
    `document_invoices/${id}`,
    config
  );
};

export const createDocumentInvoice = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialDocumentInvoiceFields,
    PartialDocumentInvoiceExtraFields
  >("document_invoices", config);
};
export const updateDocumentInvoice = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialDocumentInvoiceFields,
    PartialDocumentInvoiceExtraFields
  >(`document_invoices/${id}`, config);
};
export const deleteDocumentInvoice = (id: number) => {
  return api.remove<DocumentInvoiceFields, DocumentInvoiceExtraFields>(
    `document_invoices/${id}`
  );
};
